import 'css-chunksrc/client/common/colorPicker/styles.scss';export default {
  "colorPicker": "_colorPicker_1m8pc_1"
};